import {createGrid} from '../util/creategrid'

export const {GridProvider, Grid, Column} = createGrid({
	xxs: '(max-width: 459px)',
	xs: '(min-width: 460px)',
	s: '(min-width: 600px)',
	m: '(min-width: 768px)',
	l: '(min-width: 1024px)'
})
